import React from 'react';
import loadingGif from '../../assets/images/loader.gif';
import './InitLoader.css';

const InitLoader = ({ message = 'Initializing your session...' }) => {
  return (
    <div className="init-loader-container">
      <div className="init-loader-content">
        <div className="init-loader-icon">
          <img
            src={loadingGif}
            alt="Loading"
            className="init-loader-gif"
          />
        </div>
        <h5 className="init-loader-title">{message}</h5>
        <p className="init-loader-subtitle">
          Please wait while we retrieve your account information
        </p>
      </div>
    </div>
  );
};

export default InitLoader;
